import '../styles/plugin.scss';
import dialogConfig from './dialogConfig';
import widgetConfig from './widgetConfig';

const loadPlugin = () => {
  CKEDITOR.plugins.add('enableBinder', {
    onLoad: () => {
      window.ckeditorBinderPlugin = {};

      // here we can add css to the editor
      // we might consider extract it to another file
      // and use raw-loader to get it
      CKEDITOR.addCss(
        '.thebelab pre.no-code { display: none; }',
      );
    },
    init: (editor) => {
      console.log('CKEditor Binder Plugin')
      // not sure why allowedContent in the widgetConfig
      // won't work. So set it here
      editor.filter.allow('div(thebelab-widget);pre[data-executable,data-language,data-readonly](no-code);div[data-output]');

      // Register the dialog - dialogConfig returns a function that CKEditor will call
      CKEDITOR.dialog.add('binderDialog', function(editor) {
        return dialogConfig(editor);
      });
      
      editor.widgets.add('thebelabWidget', widgetConfig);

      // add button to toolbar
      editor.ui.addButton('enableBinder', {
        label: 'Enable Binder',
        command: 'thebelabWidget',
        toolbar: 'insert',
        icon: 'https://cdn.libretexts.net/Icons/binderhub.png',
      });
    },
  });

  if (CKEDITOR.config.extraPlugins === '') {
    CKEDITOR.config.extraPlugins += 'enableBinder';
  } else {
    CKEDITOR.config.extraPlugins += ',enableBinder';
  }
};

export default loadPlugin;
